import Snackbar from "node-snackbar";

export const presentApiErrorMessage = (component, error) => {
  const { response } = error;
  if (response) {
    const { request, ...errorObject } = response; // take everything but 'request'
    for (const [key, value] of Object.entries(errorObject.data.errors)) {
      // component.$error( value[ 0 ] );

      Snackbar.show({
        text: value[0],
        pos: "top-center",
        actionText: "x",
        duration: 3000,
        actionTextColor: "#fff",
        backgroundColor: "#dc3545"
      });
    }
  }
};
export const submitAndNotify = async (
  context,
  action,
  callback,
  msg = "Done successfully",
  errorMsg = "An unexpected error occurred."
) => {
  context.loading = true;

  action
    .then(data => {
      context.loading = false;

      if (msg) {
        Snackbar.show({
          text: msg,
          pos: "top-center",
          actionText: "x",
          duration: 3000,
          actionTextColor: "#fff",
          backgroundColor: "#28a745"
        });
      }

      context.$emit("onSubmit");

      if (callback && typeof callback === "function") {
        callback(data);
      }
      if (data && data.data && data.data.length === 0) {
        Snackbar.show({
          text: errorMsg,
          pos: "top-center",
          actionText: "x",
          duration: 3000,
          actionTextColor: "#fff",
          backgroundColor: "#dc3545"
        });
      }
    })
    .catch(error => {
      context.loading = false;
      let errorMessage = "An unexpected error occurred.";
      if (error.response && error.response.data && error.response.data.errors) {
        return presentApiErrorMessage(context, error);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      Snackbar.show({
        text: errorMessage,
        pos: "top-center",
        actionText: "x",
        duration: 3000,
        actionTextColor: "#fff",
        backgroundColor: "#dc3545"
      });
    });
};
